<template>
	<footer>
		<div class="bg-dark">
			<div class="align-footer">
				<div class="bg-dark ">
					<img src="../img/Mission_LOGO.png" alt="Mission" class="d-inline-block align-top-footer ">
				</div>
				<div class="align-custom">
				<div class="menu-footer">
					<div class="bg-dark ">
						<ul>
							<li><a class="text-footer" href="https://www.missionmag.org/category/music/">MUSIC</a></li>
              				<li><a class="text-footer" href="https://www.missionmag.org/category/film/">FILM</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/fashion-beauty/">FASHION & BEAUTY</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/culture-club/">CULTURE CLUB</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/sustainability/">SUSTAINABILITY</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/philanthropy/">PHILANTHROPY</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/news/">NEWS</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/art/">ART</a></li>
						</ul>
					</div>
					<div class="bg-dark ">
						<ul>
							<li><a class="text-footer" href="https://www.missionmagazinesubscriptions.org/">DIGITAL MAGAZINE</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/stockists/">PRINT MAGAZINE</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/polaroids/">#MYMISSIONIS</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/podcast/">PODCAST</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/youth-series/">YOUTH SERIES</a></li>
              				<li><a class="text-footer" href="https://www.missionmag.org/category/sport/">SPORT</a></li>
						</ul>
					</div>
					<div class="bg-dark ">
						<ul>
							<li><a class="text-footer" href="https://www.missionmag.org/about/">ABOUT</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/category/press/">PRESS</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/subscribe/">SUBSCRIBE</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/contact/">CONTACT</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/privacy-policy/">PRIVACY POLICY</a></li>
							<li><a class="text-footer" href="https://www.missionmag.org/donate-2/">DONATE</a></li>
							<!-- <li><a class="text-footer"  target="_blank" style="cursor: pointer;" href="https://www.missioncreativ.com/"><img src="../img/MISSION_CREATIVE_LOGOWHITE.png" alt="" width="200"></a></li> -->
							<li>
								<a class="text-footer" target="_blank" style=""
									href="https://www.facebook.com/Mission-Magazine-442919522536674/?fref=ts"><i
										class="icon-facebook"></i></a>
								<a class="text-footer" target="_blank" style="padding-left: 30px;" href="https://x.com/mission_mag"><i
										class="icon-x"></i></a>
								<a class="text-footer" target="_blank" style="padding-left: 30px;"
									href="https://www.instagram.com/missionmagazine/?hl=en"><i class="icon-instagram"></i></a>
							</li>
						</ul>
					</div>
				</div>
				<div class="bg-dark p-2 p-left-footer" style="text-align:center;">
					<img
						src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/covers%2Fissue12.png?alt=media&token=94445076-5af2-438f-b9b2-060c2b233eb6"
						style="width:80%;" alt="cover issue">
					<div class="justify-content-between custom-footer">
						<p class="text-footer">ISSUE TWELVE</p>
						<button type="button" class="btn btn-custom" @click="toUp()">BUY NOW</button>
					</div>
				</div>
			</div>
			</div>
			<div class="copyright-notice">
				<div>Copyright {{new Date().getFullYear()}} Mission Magazine. All Rights Reserved. Mission is a registered
					501(c)(3)</div>
			</div>
		</div>
	</footer>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF,faTwitter,faInstagram } from '@fortawesome/free-brands-svg-icons'
	export default {
    components: {
      FontAwesomeIcon
    },
    data() {
      return {
        face: faFacebookF,
        twit: faTwitter,
        insta: faInstagram

      }
    },
		methods:{
			toUp(){
			window.scrollTo(0,0)
		}
		}
  };
</script>
<style lang="scss">
.digital-footer {
	font-family: 'lemon_milkregular';
	color: rgb(136 136 136);
	text-align: center;
	//border-color: rgb(0 0 0);
	border-top: 1px solid rgb(75 76 77);
	padding-bottom: 20px;
}

.widget-area {
	padding-left: 30px;
	padding-right: 30px;
	background-repeat: no-repeat;
	padding-top: 43px;
	padding-bottom: 20px;
	border-top-width: 1px;
	border-color: rgb(0 0 0);
	background-size: initial;
	background-position: center center;
	color: rgb(136 136 136);
}

.widget-area {
	overflow: hidden;
	position: relative;
	border-top: 1px solid rgb(233 234 238);
	backface-visibility: hidden;
}

.align-footer {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	background-color: black;
	padding: 112px 100px;
	width: 100%;
}

.fusion-row {
	max-width: 1280px;
	margin: 0 auto;
	zoom: 1;
}

.social-networks-wrappe {
	margin: 0 -5.5px;
}

.social-networks {
	overflow: hidden;
}

.social-networks .social-network-icon {
	display: inline-block;
	margin: 0 10px 10px;
	font-size: 16px;
	text-decoration: none;
	box-shadow: none !important;
	line-height: 1;
}

.widget-area>.fusion-row {
	padding-left: 0px;
	padding-right: 0px;
}

.icon-issue {
	margin: 0 5.5px 14px;
}

.footer-widget-column {
	margin-bottom: 30px;
}

.social-networks-wrappe {
	margin: 0 -5.5px;
}

.copyright-area {
	padding-left: 30px;
	padding-right: 30px;
	padding-top: 10px;
	padding-bottom: 16px;
	border-top-width: 0px;
	border-color: rgb(0 0 0);
	z-index: 10;
	position: relative;
	// padding: 18px 10px 12px;
	//  border-top: 1px solid rgb(75 76 77);
	// background: rgb(40 42 43);
	margin-top: 20px;
}

.copyright-notice {
font-family: "belerno"!important;
	padding-bottom: 24px;
	color: rgb(255, 255, 255);
	font-size: 12px;
	text-align: center;
}

.text-footer {
	color: #fff !important;
	text-align: left;
	font-size: 1.1rem;
	line-height: 2rem;

	&:hover {
		color: #fff !important;

	}
}

.custom-footer {
	display: flex;
	width: 80%;
	margin: 0 auto;
	align-items: baseline;
}

.btn-custom {
	display: flex;
	padding: 10px 40px;
	margin-top: 20px;
	color: #FFFFFF98;
	border: 1px solid #FFFFFF98;
	border-radius: 0px;

	&:hover {
		border: 1px solid #565d62;
		color: #565d62;
	}
}

.align-top-footer {
	height: 85px !important;
}

.menu-footer {
	display: flex;
}
.align-custom{
	display: flex;
}
@media (max-width:1024px) {
	.align-custom{display: block;
	}
	.p-left-footer{
		text-align: left!important;
		padding: 40px!important;
	}
}

@media (max-width:768px) {
	.align-footer {
		display: block;
		padding: 40px 40px;
	}
	.align-top-footer {
		padding-left: 40px;
		margin-bottom: 40px;
	}

	.custom-footer{
		margin:0;
	}
	
}

@media (max-width:426px) {
	.align-footer {
		padding: 40px 0px;

	}



	.custom-footer,
	.menu-footer {
		display: block;
	}
}</style>
